import {IEnvironment} from '../app/1-application/types'

export const environment: IEnvironment = {
  apiUrl: 'https://api-auth-backend-test.ohlssons.me/api'
}